import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=931f796e&"
import script from "./GroupEdit.vue?vue&type=script&lang=ts&"
export * from "./GroupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports